module.exports = __webpack_public_path__ + "woodland.aa56af2ad6ea260976ce5bdaeb3f963c.png";